import UNIQUE from '@/common/unique'

export default {
  namespaced: true,
  state: {
  },
  actions: {
  },
  getters: {
    // string to context array
    parseFromString: () => (string) => {
      // string value parse
      function checkEl (val) {
        const parser = new DOMParser().parseFromString(val, 'text/html')
        const nodes = parser.body.childNodes
        return findDom(nodes)
      }
      /*
       * check nodeType
       * element_node(1):: implement findDom
       * text_node(3):: return textContent
      */
      function findDom (nodes) {
        let context = []
        nodes.forEach(function (node) {
          const id = UNIQUE.mid()
          const type = node.nodeType // 1: element_node, 3: text_node
          const isText = type === 3
          const isElement = type === 1
          if (isText) {
            context.push({ id: id, t: node.textContent }) // text
          } else if (isElement) {
            context.push({ e: findDom(node.childNodes) }) // element
          }
        })
        return context
      }
      return checkEl(string)
    }
  }
}
